module.exports = __webpack_public_path__ + "media/src/images/title_area-32b18519e0c7fbb085007b6e9042812a.png";